import type { CompanyMarketplace } from 'types/models/company';

export default function getMarketplaceOnboardingComplete(
  companyMarketplace: CompanyMarketplace | undefined
) {
  if (!companyMarketplace) {
    return false;
  }

  const marketplaceDone = !!(
    companyMarketplace?.primaryContact?.firstName &&
    companyMarketplace?.primaryContact?.lastName &&
    companyMarketplace?.primaryContact?.email &&
    companyMarketplace?.primaryContact?.phoneNumber &&
    companyMarketplace?.yearEstablished &&
    companyMarketplace?.location &&
    companyMarketplace?.brandCardPhoto &&
    companyMarketplace?.brandHeaderPhoto &&
    companyMarketplace?.brandProfilePhoto &&
    companyMarketplace?.revSplit &&
    companyMarketplace?.retailerAccess
  );

  return marketplaceDone;
}
